export function isStorybook() {
  return "__STORYBOOK_ADDONS_CHANNEL__" in globalThis;
}
